import type { ServerResponseV1 } from "@/http"
import { v1 } from "@/axios"

interface IUploadData {
  uploadId: string
  key: string
  partNumber: number
}

export async function signUploadPart(data: IUploadData, eventVaultId: number) {
  const response = await v1.post<ServerResponseV1<{ url: string }>>(`/upload/${eventVaultId}/multipart/sign-part`, data)

  return response.data.data?.url ?? ""
}
